import useFormData from "hooks/useFormData";

import Select from "components/Select";

export default function AddProfessionForm({ hide_text, industries, professions_options, onSubmit }) {

   const { data, onDataChange } = useFormData();

   const options = professions_options?.filter( p => {
      if ( !data.industry_id ) return true;
      return +data.industry_id === +p.industry_id
   });

   return (
      <>
         { !hide_text && 
            <p> Wybierz <strong>do 8 zawodów</strong>, które chcesz przeanalizować na wykresach. </p>
         }
         
         <div style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "20px 40px"
         }}> 
            <Select
               name="industry_id"
               value={ data.industry_id }
               placeholder="Wybierz branżę"
               ariaLabel="Wybierz branżę z listy rozwijanej"
               style={{ flex: "1 1 340px" }}
               options={ industries || []}
               onChange={( n, v ) => onDataChange({
                  [n]: v,
                  profession_id: undefined
               })}
            />

            <Select
               name="profession_id"
               value={ data.profession_id }
               placeholder="Wybierz zawód"
               ariaLabel="Wybierz zawód z listy rozwijanej"
               style={{ flex: "1 1 340px" }}
               options={ options || []}
               onChange={( n, v ) => {
                  if ( v ) {
                     onSubmit( v );
                     onDataChange( n, undefined );
                  } else {
                     onDataChange( n, v );
                  }
               }}
            />
         </div>
      </>
   )
}